import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import MainView from './views/MainView.vue';
import loading from './routes/loading';
import delivery from './routes/delivery';
import serviceOffer from './routes/serviceOffer';
import furnitures from './routes/furnitures';
import validate from './routes/validate';

Vue.use(Router);

const isNotLogged = (to, from, next) => {
  if (!store.getters['authStore/isLogged']) {
    return next();
  }
  return next({ name: 'loadingHome' });
};

const isLogged = (to, from, next) => {
  if (store.getters['authStore/isLogged']) {
    return next();
  }
  return next({ name: 'login' });
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/loading',
      component: MainView,
      children: [
        {
          path: '',
          name: 'loadingHome',
          redirect: { name: 'loadingAddress' },
        },
        ...loading.map(({
          name, path, component, meta,
        }) => ({
          name,
          path,
          meta: {
            authRequired: true,
            ...meta,
          },
          beforeEnter: isLogged,
          component: () => import(/* webpackChunkName: "[request]" */ `./components/address/${component}`),
        })),
      ],
    },
    {
      path: '/delivery',
      component: MainView,
      children: [
        {
          path: '',
          name: 'deliveryHome',
          redirect: { name: 'deliveryAddress' },
        },
        ...delivery.map(({
          name, path, component, meta,
        }) => ({
          name,
          path,
          meta: {
            authRequired: true,
            ...meta,
          },
          beforeEnter: isLogged,
          component: () => import(/* webpackChunkName: "[request]" */ `./components/address/${component}`),
        })),
      ],
    },
    {
      path: '/services',
      component: MainView,
      children: [
        {
          path: '',
          name: 'serviceOfferHome',
          redirect: { name: 'serviceOfferDates' },
        },
        ...serviceOffer.map(({ name, path, component }) => ({
          name,
          path,
          meta: {
            authRequired: true,
          },
          beforeEnter: isLogged,
          component: () => import(/* webpackChunkName: "[request]" */ `./components/serviceOffer/${component}`),
        })),
      ],
    },
    {
      path: '/furnitures',
      component: MainView,
      children: [
        {
          path: '',
          name: 'furnituresHome',
          redirect: { name: 'furnituresRooms' },
        },
        ...furnitures.map(({
          name, path, component, meta,
        }) => ({
          name,
          path,
          meta: {
            authRequired: true,
            ...meta,
          },
          beforeEnter: isLogged,
          component: () => import(/* webpackChunkName: "[request]" */ `./components/furnitures/${component}`),
        })),
      ],
    },
    {
      path: '/validate',
      component: MainView,
      children: [
        {
          path: '',
          name: 'validateHome',
          redirect: { name: 'validateConfirm' },
        },
        ...validate.map(({
          name, path, component, meta,
        }) => ({
          name,
          path,
          meta: {
            authRequired: true,
            ...meta,
          },
          beforeEnter: isLogged,
          component: () => import(/* webpackChunkName: "[request]" */ `./components/validate/${component}`),
        })),
      ],
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        layout: 'NONE',
        authRequired: false,
      },
      beforeEnter: isNotLogged,
      component: () => import(/* webpackChunkName: "[request]" */ './views/Login.vue'),
    },
  ],
});
